import { Container } from '@/atoms';
import BloqueH from '@/organisms/BloqueH';

import { BloqueHTransformer } from '@/lib/graphql/transformers/flexible';

/**
 * BloqueHTemplate
 */
export const BloqueHTemplate = ({ bloque, id }: any) => (
  <Container id={id} wrapper>
    <BloqueH {...BloqueHTransformer(bloque)} />
  </Container>
);
export default BloqueHTemplate;
BloqueHTemplate.displayName = 'BloqueHTemplate';
